import React, { useState, useEffect } from "react";
import { useCurrentPage } from "../providers/CurrentPageContext";
import { usePoints } from "../providers/PointsContext";

function Countdown() {
  const [countdown, setCountdown] = useState(3);
  const [currentPage, setCurrentPage] = useCurrentPage();
  const [readySetGo, setReadySetGo] = useState("Klara...");
  const [points, setPoints] = usePoints();

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);

      switch (countdown) {
        case 3:
          setReadySetGo("Färdiga...");
          break;
        case 2:
          setReadySetGo("Kör!");
          break;
        default:
          setReadySetGo("");
      }

      if (countdown === 1) {
        clearInterval(interval);
        setCurrentPage(2);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [countdown]);

  return (
    <section className="bg-petrol-500 flex items-center justify-center">
      {/* <p className="text-2xl font-bold mb-8 animate-bounce">{readySetGo}</p> */}
      <p className="text-2xl font-bold mb-8 animate-bounce">
        Quizzet startar om...
      </p>
      {/* <div className="mb-[18px] flex flex-col h-40 w-40 items-center justify-center rounded-full bg-[var(--color-green)]"> */}
      <h1 className="sm:text-[400px] text-[200px] animate-countdown">
        {countdown}
      </h1>
      {/* </div> */}
      {/* <Circles color="bg-syren-300" /> */}
    </section>
  );
}

export default Countdown;
